import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, Clock } from "@phosphor-icons/react";
import { CITIES, SERVICES, PHONE_DISPLAY, PHONE_TEL } from "@/seoData";
import { PaymentMethods } from "@/components/PaymentMethods";
import { FEATURED_GUIDES } from "@/seoContentV5";

export default function Footer() {
  return (
    <footer className="bg-[#0B1E45] text-white px-5 lg:px-8 pt-16 pb-28 md:pb-16">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-display font-black text-2xl tracking-tighter text-white mb-4">
            CleanOut<span className="text-[#5DB82F]">247</span>
          </div>
          <p className="text-white/60 leading-relaxed text-sm max-w-xs">
            Fast, friendly, eco-responsible junk removal proudly serving San Diego and all of San Diego County.
          </p>
          <ul className="space-y-3 text-white/90 mt-5">
            <li><a href={`tel:${PHONE_TEL}`} data-testid="footer-phone" className="flex items-center gap-2 hover:text-[#5DB82F] transition-colors"><Phone size={18} weight="fill" /> Call/Text {PHONE_DISPLAY}</a></li>
            <li><a href="mailto:office@cleanout247.com" data-testid="footer-email" className="flex items-center gap-2 hover:text-[#5DB82F] transition-colors"><EnvelopeSimple size={18} weight="fill" /> office@cleanout247.com</a></li>
            <li className="flex items-start gap-2 text-white/70"><MapPin size={18} weight="fill" className="mt-0.5 shrink-0" /> 10335 Reserve Dr, San Diego, CA 92127</li>
            <li className="flex items-center gap-2 text-white/70"><Clock size={18} weight="fill" /> Open 24/7 · Same-day service</li>
          </ul>
        </div>

        <div>
          <h2 className="font-display font-bold uppercase tracking-widest text-sm text-[#5DB82F] mb-4">Services</h2>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-white/80 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="hover:text-[#5DB82F] transition-colors">{s.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="font-display font-bold uppercase tracking-widest text-sm text-[#5DB82F] mb-4">Service Areas</h2>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-white/80 text-sm">
            {CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/junk-removal/${c.slug}`} className="hover:text-[#5DB82F] transition-colors">{c.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="font-display font-bold uppercase tracking-widest text-sm text-[#5DB82F] mb-4">Company</h2>
          <ul className="space-y-2.5 text-white/80 text-sm">
            <li><Link to="/" className="hover:text-[#5DB82F] transition-colors">Home</Link></li>
            <li><Link to="/junk-removal-cost" className="hover:text-[#5DB82F] transition-colors">Junk Removal Cost</Link></li>
            <li><Link to="/pricing-and-disposal-guide" className="hover:text-[#5DB82F] transition-colors">San Diego Dump Fees</Link></li>
            <li><Link to="/service-areas" className="hover:text-[#5DB82F] transition-colors">Service Areas</Link></li>
            <li><Link to="/blog" className="hover:text-[#5DB82F] transition-colors">Guides &amp; Tips</Link></li>
            {FEATURED_GUIDES.slice(0, 3).map((g) => (
              <li key={g.to}><Link to={g.to} className="hover:text-[#5DB82F] transition-colors">{g.label}</Link></li>
            ))}
            <li><Link to="/contact" className="hover:text-[#5DB82F] transition-colors">Contact</Link></li>
            <li><Link to="/review" className="hover:text-[#5DB82F] transition-colors">Leave a Review</Link></li>
            <li><Link to="/#estimate" className="hover:text-[#5DB82F] transition-colors">Instant Estimate</Link></li>
            <li><Link to="/#gallery" className="hover:text-[#5DB82F] transition-colors">Our Work</Link></li>
            <li><Link to="/#reviews" className="hover:text-[#5DB82F] transition-colors">Reviews</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-white/10">
        <PaymentMethods />
      </div>
      <div className="max-w-7xl mx-auto mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm text-white/50">
        <p>© {new Date().getFullYear()} CleanOut247. All rights reserved.</p>
        <p>Licensed &amp; Insured · San Diego, CA</p>
      </div>
    </footer>
  );
}
